import React, { Component } from 'react';
import { Row, Col, Button, Card, Checkbox, Divider, Modal } from 'antd';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import moment, { now } from 'moment'
import './layout.css';
import FormItem from 'antd/lib/form/FormItem';
import { history } from '../../container/History';
import PrivacyModalBox from "./PrivacyModalBox";


let today = moment().format('YYYY-MM-DD');
const ALUMNI_PRIVACY_SETTINGS_OPTIONS_DATE = process.env.REACT_APP_ALUMNI_PRIVACY_SETTINGS_OPTIONS_DATE; //Alumni Privacy Options pushed to QA/PROD DATE


class PrivacySettings extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isPrivacyVisible: false,
        isPrivacyHidden: false
      }
    }

    componentDidMount = () => {
        let loggedinUser = JSON.parse(localStorage.getItem('user'))
        let personGUID = loggedinUser.personGuid;
        let userid = loggedinUser.account.userId
        this.props.actions.getProfileInfo(personGUID)
        const needToRedirectToPrivacySettings = JSON.parse(localStorage.getItem('privacy-setting'));

        if (this.props.profileinfo) {
          let alumniPrivacyDate = this.props.profileinfo && this.props.profileinfo.extendedProfile[0] ? this.props.profileinfo.extendedProfile.filter(obj => obj.attributeId == "25") : [];
          let acceptedPrivacyDate = alumniPrivacyDate && alumniPrivacyDate[0] ? alumniPrivacyDate[0].attributeVal : []
  
          if (acceptedPrivacyDate && alumniPrivacyDate.length != 0) {
              var isPrivacyaccepted = moment(today).diff(moment(acceptedPrivacyDate), 'years') 
              if (!(isPrivacyaccepted >= 1 || moment(acceptedPrivacyDate).isBefore(ALUMNI_PRIVACY_SETTINGS_OPTIONS_DATE))) {
                this.props.actions.redirectDashboard()
              }
            }
          } else if(!needToRedirectToPrivacySettings) {
          this.props.actions.redirectDashboard()
        }
        
    }

  // componentWillUnmount = () => {
  //   let loggedinUser = JSON.parse(localStorage.getItem("user"));
  //   let personGUID = loggedinUser.personGuid;
  //   this.props.actions.getProfileInfo(personGUID);

  //   let alumniPrivacyDate =
  //     this.props.profileinfo && this.props.profileinfo.extendedProfile[0]
  //       ? this.props.profileinfo.extendedProfile.filter(
  //           (obj) => obj.attributeId == "25"
  //         )
  //       : [];

  //   if (alumniPrivacyDate.length == 0) {
  //     history.push("/privacy-setting");
  //   } else {
  //     history.push("alumni-dashboard");
  //   }
  // };

    // currentPrivacySetting = () => {
    //     if(this.props.profileinfo) {
    //         let privacySetting = this.props.profileinfo.extendedProfile.filter((data) => data.attributeId == "17")[0];

    //         if (privacySetting) {
    //             if(privacySetting.attributeVal == '0') {
    //                 return <span>Visible to other alumni</span>
    //             } else {
    //                 return <span>Hidden from other alumni</span>
    //             }
    //         } else {
    //             return <span>Hidden from other alumni</span>
    //         }
    //     }
    // }

    updatePrivacySettingAndDate = (needToRedirect, redirectTo) => {
        if(this.props.profileinfo) {
            // let existingprivacysetting = this.props.profileinfo.extendedProfile.filter((data) => data.attributeId == "17")[0];
            // let existingprivacysettingDate = this.props.profileinfo.extendedProfile.filter((data) => data.attributeId == "25")[0];


            // let privacySetting;
            // if(existingprivacysetting) {
            //     privacySetting = existingprivacysetting.extendedProfileId
            // }else{
            //     privacySetting = ''
            // }

            // let acceptedPrivacyDate = existingprivacysettingDate ? existingprivacysettingDate.attributeVal : '';
            // var isPrivacyAccepted = moment(today).diff(moment(acceptedPrivacyDate), 'years');
            
            // if( !acceptedPrivacyDate || (acceptedPrivacyDate &&  isPrivacyAccepted >= 1)) {
            //     this.props.actions.createPrivacySettingsDate(privacySetting)
            // }

            // if(this.state.isPrivacyHidden && this.state.isPrivacyVisible) {
            //     return Modal.success({
            //         className: "ErrorModal",
            //         title: 'Success',
            //         content: 'Please select a privacy setting to update!',
            //         onOk() {
            //             history.push('/privacy-setting')
            //         }
            //     });
            // }

            // if(this.state.isPrivacyVisible) {
            //     this.props.actions.updatePrivacySettings(privacySetting, '0')
            // } else if(this.state.isPrivacyHidden) {
            //     this.props.actions.updatePrivacySettings(privacySetting, '100')
            // }

            let existingPrivacySettingDate = this.props.profileinfo.extendedProfile.filter((data) => data.attributeId == "25")[0];
            let existingprivacysetting = this.props.profileinfo.extendedProfile.filter((data) => data.attributeId == "17")[0];
            let privacySettingId = (existingPrivacySettingDate && existingPrivacySettingDate.extendedProfileId) ? existingPrivacySettingDate.extendedProfileId : '';
            const oldPrivacySettings =  existingprivacysetting && existingprivacysetting.attributeVal && existingprivacysetting.attributeVal == '100' ? existingprivacysetting : '';
            this.props.actions.UpdatePrivacySettingsDate(privacySettingId, needToRedirect, redirectTo, oldPrivacySettings, this.props.profileinfo.profile.personGuid)  
        }

    }

    // visiblePrivacySettingUpdate = (e) => {
    //     console.log(e.target)
    //     if(e.target.value == '0') {
    //         console.log( 'profile info from', e.target.value)
    //         this.setState({isPrivacyVisible: true, isPrivacyHidden: false})
    //     } else if(e.target.value == '100') {
    //         console.log( 'profile info from', e.target.value)
    //         this.setState({isPrivacyVisible: false, isPrivacyHidden: true})
    //     }

    // }

    // renderUpdateButton = () => {
    //     let isDisabled = true;
    //     if(this.state.isPrivacyHidden || this.state.isPrivacyVisible) {
    //         isDisabled = false;
    //     }
    //     return (
    //         <Row type="flex" justify="space-around" className='privacy-action'>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
    //                 <Button type="primary" disabled={isDisabled} className='submit-btn' style={{ width: "50%" }} onClick={this.updatePrivacySettingAndDate}>UPDATE</Button>
    //             </Col>
    //         </Row>
    //     )
    // }

    
 render() {
    //Modal Box
    const proShowModal = () => {
      this.setState({
        isPrivacyVisible: true,
      });
    };

const proHandleOk = (e) => {
      console.log(e);
      this.setState({
        isPrivacyVisible: false,
      });
    };

    const proHandleCancel = (e) => {
      console.log(e);
      this.setState({
        isPrivacyVisible: false,
      });
    };

    return (
      <div className="widget PrivacySettings">
        <div className="widget-container">
          <Card className="toc-bg" title="PRIVACY SETTINGS">
            <div className="terms-container">
              <p className="please">
                Please update your privacy settings on whether you want other
                alumni to find you.
              </p>
              <span>
                Please Take a minute to review the Spark Directory Privacy
                Policy and update your personal security
                <br />
                settings as needed. Simple check the information you want
                displayed and visible to other alumini.
              </span>
              <div className="privacy-setting">
                <div className="a-tags">
                  <PrivacyModalBox
                    send={this.state.isPrivacyVisible}
                    okay={proHandleOk}
                    cancel={proHandleCancel}
                  />
                  <p onClick={proShowModal}>Spark Directory Privacy Policy</p>
                  <p onClick={() => this.updatePrivacySettingAndDate( true , '/my-profile')}>
                    My Privacy Settings
                  </p>
                </div>
                <div className="close-btn-div">
                  <Button
                    id="alumini-dashboard-closebtn"
                    onClick={() => this.updatePrivacySettingAndDate(true)}
                  >
                    Close
                  </Button>
                </div>
              </div>

              {/* <div className="privacy-setting-update">
                <div className="update-container">
                  <Row type="flex" justify="center" align="middle">
                    <Col className="toc-title" span={19}>
                      <span>PRIVACY SETTINGS</span>
                    </Col>
                  </Row>

                        <Row >
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <div className="Summary-title-txt" style={{ fontSize: '14px' }}>Current Privacy Setting</div>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                <div className="current-membership">
                                    <div className="EagleMembershipInfo">
                                        <span className="MembershipTypeInfoValue"> {this.currentPrivacySetting()} </span>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Divider style={{ margin: '10px 0px' }} />

                        <Row className='PrivacySettingAction'>
                                <Row>
                                    <Col xs={14} sm={14} md={14} lg={14} xl={14} >
                                        <div className='plan-selected'>I want other alumni to find me </div>
                                    </Col>
                                    <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <Checkbox className='privacytype-custom-checkbox' checked={this.state.isPrivacyVisible} onChange={ (e) => this.visiblePrivacySettingUpdate(e) } value={'0'}/>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={14} sm={14} md={14} lg={14} xl={14}>
                                        <div className='plan-selected'>I don't want other alumni to find me  </div>
                                    </Col>
                                    <Col xs={2} sm={2} md={2} lg={2} xl={2} >
                                        <Checkbox className='privacytype-custom-checkbox' checked={this.state.isPrivacyHidden}  onChange={ (e) => this.visiblePrivacySettingUpdate(e) } value={'100'}/>
                                    </Col>
                                </Row>  
                        </Row>

                        {
                            this.renderUpdateButton()
                        }
                        </div>
                    </div> */}
                   
                 </div> 
              </Card>
           </div> 
        </div>
      )
    }


}

function mapStateToProps(state) {
  return {
      loading: state.redirectdashboardreducer.loading,
      profileinfo: state.profilereducer.profileinfo,
      profileloading: state.profilereducer.loading
  }
}

function mapDispatchToProps(dispatch) {
  return {
      actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(PrivacySettings);


// WEBPACK FOOTER //
// ./src/components/Inc/PrivacySettings.js